<template>
  <div id="map-test">
    <mapbox
        access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
        :map-options="mapOptions"
        :key="markers.length"
        @map-init="displayMarkers"
        ref="mapInstance"
    />
    <CategoryCardmap class="experience-card" v-if="selectedMarker && selectedMarkerType === 'experience'" :lodging="selectedLodging" :destination="selectedLodging.destination" @unselect="unselectCardMap" :idMarker="selectedMarker" />
    <Cardmap class="lodging-card" v-if="selectedMarker && selectedMarkerType === 'lodging'" :lodging="selectedLodging" @unselect="unselectCardMap" />
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';
import CategoryCardmap from '../components/cards/CategoryCardmap.vue';
import Cardmap from '../components/cards/Cardmap.vue';
import fetcher from "../packs/shared/api.js";

export default {
  name: 'experience-map',
  props: ['markers', 'lodgings', 'selectCardMap', 'selectedExperience', 'currentLodging'],
  components: { Mapbox, CategoryCardmap, Cardmap },
  data() {
    return {
      mapOptions: {
        style: 'mapbox://styles/mapbox/streets-v10',
        zoom: 8,
        center: this.calculateCenter(),
      },
      selectedMarker: null,
      selectedLodging: null,
      previousZoom: null,
      previousCenter: null,
      isPhone: window.innerWidth < 768,
      nearbyLodgings: [],
      selectedMarkerType: 'experience', // Track whether selected marker is experience or lodging
    };
  },
  mounted() {
    // Log all props when the component is mounted
    console.log("Props in this component:");
    console.log("Markers:", this.markers);
    console.log("Lodgings:", this.lodgings);
    console.log("SelectCardMap:", this.selectCardMap);
    console.log("selectedExperience:", this.selectedExperience);
    console.log("currentLodging:", this.currentLodging);
    
    // Fetch nearby lodgings if currentLodging is provided
    // Only fetch nearby lodgings when we have a real lodging id
    // (not a synthetic one from ExperienceDestinations)
    if (this.currentLodging && this.currentLodging.id && !this.currentLodging._synthetic) {
      this.fetchNearbyLodgings(this.currentLodging.id);
    }
  },
  methods: {
    async fetchNearbyLodgings(lodgingId) {
      try {
        const response = await fetcher.get(`/lodgings/${lodgingId}/nearby`);
        this.nearbyLodgings = [...response.data.nearby, this.currentLodging];
        console.log('Nearby lodgings fetched:', this.nearbyLodgings);
        
        // Re-render markers if map is already initialized
        if (this.$refs.mapInstance && this.$refs.mapInstance.map) {
          this.displayMarkers(this.$refs.mapInstance.map);
        }
      } catch (e) {
        console.error('Error fetching nearby lodgings:', e);
      }
    },
    calculateCenter() {
      if (!this.markers || this.markers.length === 0) {
        if (this.currentLodging && this.currentLodging.longitude && this.currentLodging.latitude) {
          return [this.currentLodging.longitude, this.currentLodging.latitude];
        }
        return [2.3522, 48.8566]; // Fallback: Paris
      }
      
      let latitudes = this.markers.map(marker => marker[1]);
      let longitudes = this.markers.map(marker => marker[0]);

      let centerLat = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
      let centerLng = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;

      return [centerLng, centerLat];
    },
    displayMarkers(map) {
      console.log("mapppp", map)
      console.log("this.markersthis.markers", this.markers)
      if (!map) return;

      // Clear existing markers
      const existingMarkers = document.querySelectorAll('.experience-all-marker, .nearby-lodging-marker');
      existingMarkers.forEach(marker => marker.remove());

      // Display experience markers
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach((marker, index) => {
          let selectedImage;
          if (marker[3] === 'culturelles') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culturelles.svg";
          } else if (marker[3] === 'au bord de l\'eau') {  // Handle apostrophe here
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/au_bord.svg";
          } else if (marker[3] === 'au naturel') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/au_nature.svg";
          } else if (marker[3] === 'sportives') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/sportives.svg";
          } else if (marker[3] === 'immersives') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/immersives.svg";
          } else if (marker[3] === 'culinaires') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culinaires.svg";
          } else if (marker[3] === 'DIY'|| marker[3] === 'diy') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/DIYS.svg";
          } else if (marker[3] === 'oenologiques') {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/oenologiques.svg";
          } else {
            selectedImage = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/culturelles.svg";  // Default image
          }

          let el = document.createElement('div');
          el.id = `experience-all-marker-${index}`;
          el.className = 'experience-all-marker';

          let img = document.createElement('img');
          img.src = selectedImage;
          img.style.width = '50px';
          img.style.height = '50px';
          el.appendChild(img);

          // Find the experience name for this marker
          if (!this.isPhone) {
            const experience = this.lodgings.find(lodging => lodging.id === marker[2]);
            const experienceName = experience ? experience.name : `Experience ${marker[2]}`;

            // Create tooltip element
            let tooltip = document.createElement('div');
            tooltip.className = 'marker-tooltip';
            tooltip.textContent = experienceName;
            tooltip.style.display = 'none';
            el.appendChild(tooltip);

            // Add hover events for tooltip
            el.addEventListener('mouseenter', () => {
              tooltip.style.display = 'block';
            });

            el.addEventListener('mouseleave', () => {
              tooltip.style.display = 'none';
            });
          }

          // Add click event to select the marker
          el.addEventListener('click', () => {
            this.selectMarker(marker[2], 'experience');
            this.previousZoom = map.getZoom();
            this.previousCenter = map.getCenter();
            map.flyTo({
              center: [marker[0], marker[1]],
              zoom: 20
            });
          });

          // Add the marker to the map
          new mapboxgl.Marker(el)
            .setLngLat([marker[0], marker[1]])
            .addTo(map);
        });
      }

      // Display nearby lodging markers
      if (this.nearbyLodgings && this.nearbyLodgings.length > 0) {
        this.nearbyLodgings.forEach((lodging, index) => {
          if (lodging.longitude && lodging.latitude) {
            let el = document.createElement('div');
            el.id = `nearby-lodging-${lodging.id}`;
            el.className = 'nearby-lodging-marker';

            let img = document.createElement('img');
            img.src = "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/lodge_building.png";
            img.style.width = '30px';
            img.style.height = '30px';
            el.appendChild(img);

            // Add tooltip for nearby lodging
            if (!this.isPhone) {
              let tooltip = document.createElement('div');
              tooltip.className = 'marker-tooltip';
              tooltip.textContent = lodging.name || `Lodging ${lodging.id}`;
              tooltip.style.display = 'none';
              el.appendChild(tooltip);

              // Add hover events for tooltip
              el.addEventListener('mouseenter', () => {
                tooltip.style.display = 'block';
              });

              el.addEventListener('mouseleave', () => {
                tooltip.style.display = 'none';
              });
            }

            // Add click event to select the nearby lodging marker
            el.addEventListener('click', () => {
              this.selectMarker(lodging.id, 'lodging');
              this.previousZoom = map.getZoom();
              this.previousCenter = map.getCenter();
              map.flyTo({
                center: [lodging.longitude, lodging.latitude],
                zoom: 20
              });
            });

            // Add the marker to the map
            new mapboxgl.Marker(el)
              .setLngLat([lodging.longitude, lodging.latitude])
              .addTo(map);
          }
        });
      }

      // Fit map to show only experience markers (not nearby lodgings)
      if (this.markers && this.markers.length > 0) {
        this.fitMapToMarkers(map, this.markers);
      }

      const mapInstance = this.$refs.mapInstance.map;
      // Add geolocation control to the map
      if (mapInstance) {
        mapInstance.addControl(new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true,
          showUserHeading: true
        }));
      }
      console.log("this.markers", this.markers)
      console.log("this.nearbyLodgings", this.nearbyLodgings)
    },
    fitMapToMarkers(map, markers) {
      if (!markers || markers.length === 0) return;
      
      const bounds = new mapboxgl.LngLatBounds();
      markers.forEach(marker => bounds.extend([marker[0], marker[1]]));
      map.fitBounds(bounds, {
        padding: 50
      });
    },
    selectMarker(markerId, type = 'experience') {
      this.selectedMarker = markerId;
      this.selectedMarkerType = type;
      if (type === 'lodging') {
        // For nearby lodgings, find from nearbyLodgings array
        this.selectedLodging = this.nearbyLodgings.find(lodging => lodging.id === parseInt(markerId));
      } else {
        // For experiences, find from lodgings array
        this.selectedLodging = this.lodgings.find(lodging => lodging.id === parseInt(markerId));
      }
    },
    unselectCardMap() {
      this.selectedMarker = null;
      this.selectedLodging = null;
      this.selectedMarkerType = 'experience';
      this.restoreMapState();
    },
    restoreMapState() {
      if (this.previousCenter && this.previousZoom !== null) {
        const map = this.$refs.mapInstance.map;
        map.flyTo({
          center: this.previousCenter,
          zoom: this.previousZoom,
        });
      }
    }
  },
  watch: {
    markers(newMarkers) {
      console.log('Markers updated:', newMarkers);
      // Recalculate map center when markers change
      this.mapOptions.center = this.calculateCenter();
      this.$nextTick(() => {
        if (this.$refs.mapInstance && this.$refs.mapInstance.map) {
          this.displayMarkers(this.$refs.mapInstance.map);
        }
      });
    },
    lodgings(newLodgings) {
      console.log('Lodgings updated:', newLodgings);
    },
    selectedExperience(newVal) {
      console.log("Updated selectedExperience:", newVal);
      if (newVal && newVal.id && this.$refs.mapInstance && this.$refs.mapInstance.map) {
        // Select the focused experience and fly to it
        this.selectMarker(newVal.id, 'experience');
        const map = this.$refs.mapInstance.map;
        map.flyTo({
          center: [newVal.longitude, newVal.latitude],
          zoom: 20
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.marker {
  background-color: yellow !important;
  border: 2px solid red !important;
  cursor: pointer !important;
  position: relative !important;
}

#card-map {
  position: absolute;
  top: auto;
  left: 10%;
  width: 100%;
  z-index: 99;
  background: white;
  border-radius: 5px;
  border-color: #B3B3B3;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#card-map .card-map {
  display: block;
  max-width: 200px;
}

#card-map .card-map .hub-img {
  width: 100%;
  margin-bottom: 2rem;
  padding-right: 0;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .experience-card {
    position: absolute;
    top: auto;
    width: 42% !important;
    z-index: 99;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 780px) {
  #map-test {
    width: 100% !important;
    margin: auto !important;
  }
}

@media only screen and (min-width: 768px) {
  #map-test #map {
  height: 500px !important;
}
#map-test {
  margin-bottom: 0px !important;
}
}

.mapboxgl-map {
  margin-bottom: 0px !important;
}


#map-test #map {
  margin-right: 0;
}

.mapboxgl-map {
  width: 100% !important;
}
.mapboxgl-canvas {
  width: 100% !important;
}

#map-test #map {
  max-width: 100% !important;
}

.experience-all-marker {
  position: relative;
}

.nearby-lodging-marker {
  cursor: pointer;
}

.nearby-lodging-marker img {
  transition: transform 0.2s ease;
}

.nearby-lodging-marker:hover img {
  transform: scale(1.1);
}
</style>
<style lang="scss"> 
@media screen and (min-width: 400px) and (max-width: 768px) {
  .experience-map-modal #map-test {
    height: 82vh !important;
    width: 100% !important;
  }
}

@media screen and (min-width: 300px) and (max-width: 399px) {
  .experience-map-modal #map-test {
    height: 75vh !important;
    width: 100% !important;
  }
}

@media screen and (min-width: 400px) and (max-width: 768px) {
  #map-container-exp #map-test {
    height: 84vh !important;
    width: 100% !important;
  }
}

@media screen and (min-width: 300px) and (max-width: 399px) {
  #map-container-exp #map-test {
    height: 75vh !important;
    width: 100% !important;
  }
}

.marker-tooltip {
  position: absolute;
  bottom: 55px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1003;
  pointer-events: none;
}

.marker-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}

.lodging-card {
  width: 40% !important;

  @media screen and (max-width: 768px) {
    width: 60% !important;
  }
}
</style>